import { forwardRef, ForwardRefExoticComponent, PropsWithoutRef, RefAttributes } from 'react';
import QuestionInterface from '../../../interfaces/question';
import { limitPhrase } from '../../../utils/questionLimits';
import QuestionFactory from '../utils/questionFactory';
import * as styles from './Question.module.css';

interface QuestionProps {
  question: QuestionInterface;
  errors: Array<string>;
}
const Question: ForwardRefExoticComponent<
  PropsWithoutRef<QuestionProps> & RefAttributes<HTMLDivElement>
> = forwardRef<HTMLDivElement, QuestionProps>(function ForwardedQuestion(
  { question, errors },
  ref,
) {
  const renderLimitPhrases = () => {
    const questionLimit = limitPhrase({ question });
    if (questionLimit) {
      const styleError = errors.includes(questionLimit) ? styles.error : '';
      return (
        <div className={styles.limitPhrases}>
          <p className={`${styles.phrase} ${styleError}`} key={`error-${question.id}`}>
            {questionLimit}
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div ref={ref} className={styles.questionContainer}>
      <div className={styles.questionLabelContainer}>
        <p className={styles.questionLabel}>{question.value}</p>
        {question.caption && <p className={styles.questionSubLabel}>{question.caption}</p>}
      </div>
      {renderLimitPhrases()}
      <QuestionFactory question={question} />
    </div>
  );
});

export default Question;
